module.exports = __webpack_public_path__ + "img/12_65.8d8f52d9.png";